import type { FC } from 'react';
import officialUserBadgeImage from '~/app/_components/username-with-badge/assets/official-user-badge.svg';
import vipUserBadgeImage from '~/app/_components/username-with-badge/assets/vip-badge.png';
import { Link } from '@app/_components/link';
import { css } from '@styled-system/css';
import { Box, HStack, Paragraph } from '@styled-system/jsx';
import userPlaceholder from './assets/user-placeholder.png';

export type Props = {
  userId: string;
  username: string | undefined;
  thumbnail: string | undefined;
  isOfficialWriter?: boolean;
  isVip?: boolean;
  type: 'small' | 'large';
  // リンクをnofollowにするかどうか
  nofollow?: boolean;
};

export const UserThumbnailWithNameAndBadges: FC<Props> = ({
  userId,
  username,
  thumbnail,
  isOfficialWriter,
  isVip,
  type,
  nofollow,
}) => {
  return (
    <Box display="flex" width="100%" alignItems="center" marginRight="16px">
      <Link
        href={`/user/${userId}`}
        rel={nofollow ? 'nofollow' : undefined}
        className={css({
          display: 'flex',
          alignItems: 'center',
          _focus: {
            outline: 0,
            outlineColor: 'transparent',
            outlineStyle: 'none',
          },
        })}
      >
        <img
          src={thumbnail ? `${thumbnail}=s100` : userPlaceholder}
          alt={username || ''}
          width={type === 'small' ? 24 : 40}
          height={type === 'small' ? 24 : 40}
          className={css({
            display: 'block',
            borderRadius: '50%',
            marginRight: '12px',
            minWidth: type === 'small' ? '16px' : '40px',
            minHeight: type === 'small' ? '16px' : '40px',
            width: type === 'small' ? '24px' : '40px',
            height: type === 'small' ? '24px' : '40px',
            border: '1px solid rgb(49, 50, 56, 0.3)',
            objectFit: 'cover',
          })}
          loading="lazy"
        />
        <HStack gap="4px" alignItems="center">
          <Paragraph
            fontSize={type === 'small' ? 'size_12' : 'size_14'}
            color="accent.700"
            maxLines="1"
            fontWeight={type === 'small' ? 'normal' : '700'}
          >
            {username || 'ゲスト'}
          </Paragraph>
          {isOfficialWriter && (
            <img
              alt="公式"
              loading="lazy"
              src={officialUserBadgeImage}
              className={css({
                w: '12px',
                h: '12px',
              })}
            />
          )}
          {!isOfficialWriter && isVip && (
            <img
              alt="VIP"
              loading="lazy"
              src={vipUserBadgeImage}
              className={css({
                w: '22px',
                h: '12px',
              })}
            />
          )}
        </HStack>
      </Link>
    </Box>
  );
};
